/**
 * HOTFIX — choix d'endpoint remboursement depuis l'écran Caisse (Historique).
 * Réutilise canRefundWebEncaisseCaisse (ROUTE-2) ; POS inchangé ; Web non éligible → BLOCKED.
 */

import {
  canRefundWebEncaisseCaisse,
  getCommandeSoldeRemboursable,
  hasStripePaymentIntent,
  isCommandePaiementEnLigne,
  hasMixedStripeAndCaisseEncaissement,
  hasCaisseLedgerEncaissement,
} from './mesCommandesOrderDetailFinance.js';

export const CAISSE_REFUND_API = Object.freeze({
  WEB_ENCAISSE_ROUTE2: 'WEB_ENCAISSE_ROUTE2',
  POS_TICKET: 'POS_TICKET',
  BLOCKED: 'BLOCKED',
});

/**
 * @param {object|null|undefined} ticketDetail — commande / ticket détail caisse
 * @returns {'WEB_ENCAISSE_ROUTE2'|'POS_TICKET'|'BLOCKED'}
 */
export function pickCaisseRefundApi(ticketDetail) {
  if (!ticketDetail) return CAISSE_REFUND_API.BLOCKED;
  if (ticketDetail.canalVente === 'POS') {
    return CAISSE_REFUND_API.POS_TICKET;
  }
  if (canRefundWebEncaisseCaisse(ticketDetail)) {
    return CAISSE_REFUND_API.WEB_ENCAISSE_ROUTE2;
  }
  return CAISSE_REFUND_API.BLOCKED;
}

/** Message commerçant lorsque le remboursement caisse est refusé côté UI (Web non ROUTE-2). */
export function getCaisseRefundBlockedMessage(ticketDetail) {
  if (!ticketDetail || ticketDetail.canalVente === 'POS') return null;
  if (canRefundWebEncaisseCaisse(ticketDetail)) return null;

  if (hasMixedStripeAndCaisseEncaissement(ticketDetail)) {
    return 'Paiement mixte (en ligne + caisse) : le remboursement ne peut pas être effectué depuis la caisse. Contactez le support ou traitez la commande depuis Mes commandes.';
  }
  if (isCommandePaiementEnLigne(ticketDetail) || hasStripePaymentIntent(ticketDetail)) {
    return 'Commande payée en ligne : effectuez le remboursement depuis Mes commandes (parcours Stripe).';
  }
  if (!hasCaisseLedgerEncaissement(ticketDetail)) {
    return 'Cette commande web n’a pas de preuve d’encaissement en caisse : remboursement impossible depuis l’historique caisse.';
  }
  const solde = getCommandeSoldeRemboursable(ticketDetail);
  if (solde <= 0.01) {
    return 'Aucun montant remboursable restant sur cette commande depuis la caisse.';
  }
  return 'Remboursement impossible depuis la caisse pour cette commande. Utilisez Mes commandes si un autre parcours s’applique.';
}
